/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Validation: React.FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10 1.25C14.8325 1.25 18.75 5.16751 18.75 10C18.75 14.8325 14.8325 18.75 10 18.75C5.16751 18.75 1.25 14.8325 1.25 10C1.25 5.16751 5.16751 1.25 10 1.25ZM10 2.75C5.99594 2.75 2.75 5.99594 2.75 10C2.75 14.0041 5.99594 17.25 10 17.25C14.0041 17.25 17.25 14.0041 17.25 10C17.25 5.99594 14.0041 2.75 10 2.75ZM12.3867 7.38672C12.6796 7.09388 13.1544 7.09399 13.4473 7.38672C13.74 7.67963 13.7401 8.15443 13.4473 8.44727L9.28125 12.6143C8.98851 12.9068 8.51358 12.9066 8.2207 12.6143L6.55371 10.9473C6.26087 10.6544 6.26099 10.1796 6.55371 9.88672C6.82831 9.61211 7.26304 9.59465 7.55762 9.83496L7.61426 9.88672L8.75 11.0225L12.3867 7.38672Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default Validation;
